import { forwardRef, ReactNode } from 'react'

import { styled } from 'styled-components'

import { useDarkModeInfo } from 'core/theme/DarkModeProvider'
import color from 'peach/helpers/color/color'

const colors = {
  object: '#444',
  emptyObject: '#AAA',
  array: '#444',
  emptyArray: '#AAA',
  key: '#222',
  text: '#666',
  boolean: '#573b79',
  string: '#d28140',
  emptyString: '#AAA',
  empty: '#AAA',
  id: '#7e96c4',
  number: '#7e96c4',
  date: '#1050c0',
  amount: '#3d9970',
  undefined: '#f8b8b7',
  null: '#f8b8b7',
  index: '#888',
  unknown: '#444',
}

const keys = ['text', 'key']

const getColor = (type, darkMode) => {
  const rawColor = colors[type] || colors.unknown
  return darkMode ? color.preventTooDark(rawColor) : rawColor
}

const DisplayValue = styled.span<{ $type?: string; $darkMode: string }>`
  white-space: pre-wrap;
  word-break: ${(p) => (p.$type === 'index' ? 'keep-all' : 'break-word')};
  color: ${(p) => {
    return keys.includes(p.$type || '')
      ? p.theme.text
      : getColor(p.$type || '', p.$darkMode)
  }};
  font-family: Inter, Heebo, sans-serif;
  font-size: 12px;
  font-weight: ${(p) => (p.$type === 'key ' ? '600' : '')};
`

type JsonDisplayValueProps = {
  children?: ReactNode
  type?: string
  onDoubleClick?: () => void
}
const JsonDisplayValue = forwardRef<HTMLInputElement, JsonDisplayValueProps>(
  ({ type, children, ...restProps }, ref) => {
    const { darkMode } = useDarkModeInfo()

    return (
      <DisplayValue $darkMode={darkMode} $type={type} {...restProps} ref={ref}>
        {children}
      </DisplayValue>
    )
  },
)

export default JsonDisplayValue
